// Google Analytics 4 Event Tracking Utility

/**
 * Track custom events in Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track page views (for SPAs)
 * @param {string} pagePath - Path of the page
 * @param {string} pageTitle - Title of the page
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

/**
 * Track booking form submission
 * @param {object} bookingData - Booking details
 */
export const trackBookingSubmission = (bookingData) => {
  trackEvent('booking_submission', {
    vehicle_type: bookingData.vehicleType,
    service_package: bookingData.service,
    addons_count: bookingData.addons?.length || 0,
    value: bookingData.estimatedPrice || 0,
  });
};

/**
 * Track "Book Now" button clicks
 * @param {string} location - Where the button was clicked (hero, services, header)
 */
export const trackBookNowClick = (location) => {
  trackEvent('book_now_click', {
    button_location: location,
  });
};

/**
 * Track phone number clicks
 */
export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    action: 'call',
  });
};

/**
 * Track admin login
 */
export const trackAdminLogin = (success) => {
  trackEvent('admin_login', {
    success: success,
  });
};

/**
 * Track service selection
 * @param {string} serviceName - Name of the selected service
 */
export const trackServiceSelection = (serviceName) => {
  trackEvent('service_selection', {
    service_name: serviceName,
  });
};
